import React from 'react'
import { IconProps } from '../../types/types'

const FileIconNoName:React.FC<IconProps> = ({ width = 31, height = 41, color = '#C8D2E1' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 31 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_132_24034)">
        <path d="M4.00586 0.750977H17.1885L29.249 12.8115V35.9941C29.2489 37.7916 27.7916 39.2489 25.9941 39.249H4.00586C2.20835 39.2489 0.751053 37.7916 0.750977 35.9941V4.00586C0.751052 2.20835 2.20835 0.751053 4.00586 0.750977Z" fill="white" stroke={color} stroke-width="1.50225"/>
        <path d="M17.0273 1V10.0135C17.0273 11.6728 18.3725 13.018 20.0318 13.018H29.0453" stroke={color} stroke-width="1.50225" stroke-linecap="round"/>
        </g>
        <defs>
        <clipPath id="clip0_132_24034">
        <rect width="30.045" height="40.06" fill="white"/>
        </clipPath>
        </defs>
    </svg>
  )
}

export default FileIconNoName